module.exports = __webpack_public_path__ + "static/Unisel7-6455bb2c4291ece3488b1d12cee382ad.jpg";